export default __webpack_public_path__ + "static/media/our_projects_heading.8ef255a6.png";